import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import QuickAccess from "./components/QuickAccess";
import StoryIntro from "./components/StoryIntro";
import NovelSection from "./components/NovelSection";
import ComicSection from "./components/ComicSection";
import FanSection from "./components/FanSection";
import ExtraSection from "./components/ExtraSection";
import SeasonSection from "./components/SeasonSection";
import SimilarSection from "./components/SimilarSection";
import GuideSection from "./components/GuideSection";
import ClosingCta from "./components/ClosingCta";

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <QuickAccess />
        <StoryIntro />
        <NovelSection />
        <ComicSection />
        <FanSection />
        <ExtraSection />
        <SeasonSection />
        <SimilarSection />
        <GuideSection />
        <ClosingCta />
      </main>
      <SiteFooter />
    </div>
  );
}